import { Popover } from 'react-tiny-popover';
import { FavouritesAddedHook } from '../hooks/fav.favAdded.hook.js';
import { FavPopupContentFavAdded } from './fav-popup-content-fav-added.js';

type ISearchBarFavPopupClickAreaProps = {
  children: JSX.Element;
};

export const FavPopupMainFavAdded = ({ children }: ISearchBarFavPopupClickAreaProps) => {
  const { displayFavAdded } = FavouritesAddedHook();

  return (
    <div data-comp="favourite-popover-add" className="u-flex">
      <Popover
        isOpen={displayFavAdded}
        align="end"
        containerClassName="SearchBar-favourites-popover"
        reposition={false}
        positions={['bottom']}
        content={({ position, childRect, popoverRect }) => {
          return <FavPopupContentFavAdded position={position} childRect={childRect} popoverRect={popoverRect} />;
        }}
      >
        {/* 
        This click holds the click event
        The child you supply react-tiny-popover with needs to support ref 
        */}
        {children}
      </Popover>
    </div>
  );
};
